import React from 'react';
import axios from 'axios';
import moment from 'moment';
import { BarChart, XAxis, Tooltip, Bar, Cell, LabelList } from 'recharts';
import { Table, Header, Segment, Loader, Grid } from 'semantic-ui-react';
import { center, colorss as colors } from '../../Statistics/util';
import { FormattedMessage } from 'react-intl';
import SimpleTwoColumnTableRow from '../../StudentPersonalInfo/SimpleTwoColumnTableRow';

axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;
// axios.defaults.crossDomain = true;

const style = {
    top: 0,
    left: 350,
    lineHeight: '20px'
};

export default class ExamStatistic extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            data: [],
            loading: true
        };
    }

    componentDidMount() {
        axios.get(`/exams/statistics/${this.props.gradedActivityId}`)
            .then(res => {
                this.setState({
                    data: res.data.map(el => ({
                        ...el,
                        attention: (parseInt(el.numberOfStudentsThatAttendedExam, 10) / parseInt(el.numberOfStudentsThatRegisteredExam, 10) * 100).toFixed(0) === 'NaN' ? '0' : (parseInt(el.numberOfStudentsThatAttendedExam, 10) / parseInt(el.numberOfStudentsThatRegisteredExam, 10) * 100).toFixed(0) + '%',
                        passed: (parseInt(el.numberOfStudentsThatPassedExam, 10) / parseInt(el.numberOfStudentsThatAttendedExam, 10) * 100).toFixed(0) === 'NaN' ? '0' : (parseInt(el.numberOfStudentsThatPassedExam, 10) / parseInt(el.numberOfStudentsThatAttendedExam, 10) * 100).toFixed(0) + '%'
                    })),
                    loading: false
                });
            })
            .catch(err => {
                console.log('Failed to fetch filter results');
            });
    }


    render() {
        const { data } = this.state;
        if (this.state.loading) return <div style={{ paddingTop: '100px', paddingBottom: '100px' }}><Loader active inline="centered" /></div>;
        return (
            <div>
                <Grid columns="equal" centered className="stackable">
                    <Grid.Row stretched>
                        <Grid.Column>
                            <br /><br />
                            <Table celled unstackable compact>
                                <Table.Header>
                                    <Table.Row>
                                    </Table.Row>
                                </Table.Header>
                                <Table.Body>
                                    <SimpleTwoColumnTableRow
                                        name={<FormattedMessage id="professorInputGrades.registration" />}
                                        keyName="registration"
                                        value={data.length !== 0 ? data[0].numberOfStudentsThatRegisteredExam : null}
                                    />
                                    <SimpleTwoColumnTableRow
                                        name={<FormattedMessage id="professorInputGrades.attention" />}
                                        keyName="attention"
                                        value={data.length !== 0 ? data[0].numberOfStudentsThatAttendedExam + ' (' + data[0].attention + ')' : null}
                                    />
                                    <SimpleTwoColumnTableRow
                                        name={<FormattedMessage id="professorInputGrades.passed" />}
                                        keyName="passed"
                                        value={data.length !== 0 ? data[0].numberOfStudentsThatPassedExam + ' (' + data[0].passed + ')' : null}
                                    />
                                    <SimpleTwoColumnTableRow
                                        name={<FormattedMessage id="professorInputGrades.averageGradeNew" />}
                                        keyName="averageGrade"
                                        value={data.length !== 0 ? Number(data[0].averageGrade).toFixed(2) : null}
                                    />
                                </Table.Body>
                            </Table>

                        </Grid.Column>
                        <Grid.Column>
                            <br />
                            {this.state.data.map((el) =>
                                (
                                    <BarChart
                                        width={400}
                                        height={200}
                                        style={center}
                                        margin={{ top: 20 }}

                                        data={[
                                            { name: 'prijave', 'broj studenata': el.numberOfStudentsThatRegisteredExam },
                                            { name: 'izlaznost', 'broj studenata': el.numberOfStudentsThatAttendedExam },
                                            { name: 'prolaznost', 'broj studenata': el.numberOfStudentsThatPassedExam },
                                        ]}
                                    >
                                        <XAxis dataKey="name" />
                                        <Tooltip />
                                        <Bar
                                            dataKey="broj studenata"
                                            isAnimationActive
                                        >
                                            {
                                                [1, 2, 3].map((entry, index) => (
                                                    <Cell key={`cell-${index}`} fill={colors[index]} />
                                                ))
                                            }
                                            <LabelList dataKey="broj studenata" position="top" fill="#001942" />
                                        </Bar>
                                    </BarChart>

                                ))
                            }

                            <br />

                        </Grid.Column>
                    </Grid.Row>
                </Grid>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/StudentService/Exams/ExamStatistic.js